import { useEffect, useContext, useState } from 'react'
import AccountInformation from './AccountInformation/AccountInformation';
import ProductInformation from './ProductInformation/ProductInformation';
import DownloadAttachment from './DowloadAttachment/DownloadAttachment';
import DeliveryDetails from './DeliveryDetails/DeliveryDetails';
import OrderDetails from "./OrderDetails/OrderDetails";
import OTPVerification from './OTPVerification/OTPVerification';
import Error from '../Common/Error/Error';
import { GlobalContext } from '../../context/GlobalContext';
import { useTranslation } from 'react-i18next';
import Loader from '../Loader/Loader';
import { getCities, getNationalities } from '../../api/api';
import RedownloadAttachments from './ReuploadDocuments/DownloadAttachments/RedownloadAttachments ';

function FastTrackOrder() {
    const { t } = useTranslation();
    const [state, dispatch]: any = useContext(GlobalContext);
    const { rtl, currentPage, modalOpenOtpPage, modalOpenOrderDetails } = state;
    const fixScroll = modalOpenOtpPage || modalOpenOrderDetails ? 'fixScroll' : '';
    const [hashValue, setHashValue] = useState('');
    const [, setStatus] = useState(null);

    useEffect(() => {
        if (document.getElementById('mobily_cart_id') !== null) {
            document.getElementById('mobily_cart_id').style.display = 'none';
            document.getElementById('mobily_track_order_id').style.display = 'none';
        }
        dispatch({ type: 'INITIAL_ONLOAD', payload: { page: t("Account_Information") } })
    }, [dispatch, t]);

    useEffect(() => {
        if (modalOpenOrderDetails) {
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        }
    }, [modalOpenOrderDetails])
    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    }, [currentPage])

    useEffect(() => {
        fetchDropdownLists()
    }, [])

    const fetchDropdownLists = async () => {
        try {
            const cities: any = await getCities()
            const nationalities: any = await getNationalities()
            const citiesList = JSON.parse(cities.data.data.cities).map((c: any) => {
                return { text: rtl ? c.city_desc_ar : c.city_desc_en, value: c['city code'] }
            })
            const nationalitiesList = JSON.parse(nationalities.data.data.nationalities).map((n: any) => {
                return { text: rtl ? n.item_desc_ar : n.item_desc_en, value: n['sfa code'] }
            })
            dispatch({ type: 'UPDATE_CITIES', payload: citiesList })
            dispatch({ type: 'UPDATE_NATIONALITIES', payload: nationalitiesList })
        } catch (err) {
            dispatch({ type: 'UPDATE_CITIES', payload: [] })
            dispatch({ type: 'UPDATE_NATIONALITIES', payload: [] })
        }
    }
    return (
        <div className={fixScroll}>
            <Loader />
            {currentPage === t("Account_Information") && <AccountInformation rtl={rtl} />}
            {currentPage === t("Product_Information") && <ProductInformation rtl={rtl} />}
            {currentPage === t("Delivery_Details") && <DeliveryDetails rtl={rtl} />}
            {currentPage === t("Download_Attach") && <DownloadAttachment rtl={rtl} />}
            {currentPage === t("Failed_to_submit") && <Error rtl={rtl} />}
            {modalOpenOrderDetails && <OrderDetails rtl={rtl} handleHashValue={setHashValue} handleStatus={setStatus} />}
            {modalOpenOtpPage && <OTPVerification rtl={rtl} hashValue={hashValue} />}

        </div>
    )
}

export default FastTrackOrder
